function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.987 4.08a.975.975 0 0 0-.318-.823L.32.423V0h7.303l5.645 12.381L18.23 0h6.963v.423l-2.011 1.928a.59.59 0 0 0-.224.565v14.169a.588.588 0 0 0 .224.564l1.964 1.928V20h-9.88v-.423l2.035-1.976c.2-.199.2-.258.2-.563V5.585l-5.657 14.369h-.764L4.493 5.585v9.63c-.055.405.08.813.364 1.105l2.646 3.21v.424H0v-.424l2.646-3.21a1.28 1.28 0 0 0 .341-1.104V4.08z",
  fill: "url(#medium_svg__paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "medium_svg__paint0_linear",
  x1: 0,
  y1: 0,
  x2: 19.479,
  y2: 24.536,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})));

var SvgMedium = function SvgMedium(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgc3R5bGU9Im1peC1ibGVuZC1tb2RlOmhhcmQtbGlnaHQiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIuOTg3NDYgNC4wODAyQzMuMDE4OTUgMy43NzA1MyAyLjkwMDMzIDMuNDY1MDcgMi42Njk0IDMuMjU3MjNMMC4zMTgwNiAwLjQyMzAzMVYwSDcuNjIxOUwxMy4yNjcyIDEyLjM4MTNMMTguMjMwMiAwSDI1LjE5MjlWMC40MjMwMzFMMjMuMTgxNyAyLjM1MTM0QzIzLjAwODQgMi40ODM2IDIyLjkyMjQgMi43MDA4OSAyMi45NTgxIDIuOTE2MDhWMTcuMDg1QzIyLjkyMjQgMTcuMjk5MSAyMy4wMDg0IDE3LjUxNjQgMjMuMTgxNyAxNy42NDg3TDI1LjE0NTYgMTkuNTc3VjIwSDE1LjI2NThWMTkuNTc3TDE3LjMwMTIgMTcuNjAxNEMxNy41MDA3IDE3LjQwMiAxNy41MDA3IDE3LjM0MzIgMTcuNTAwNyAxNy4wMzc3VjUuNTg1NDdMMTEuODQzOCAxOS45NTM4SDExLjA3OTZMNC40OTI3MyA1LjU4NTQ3VjE1LjIxNTVDNC40MzgxNSAxNS42MTk2IDQuNTcyNTEgMTYuMDI3OSA0Ljg1Njk4IDE2LjMxOTdMNy41MDMyOCAxOS41Mjk3VjE5Ljk1MzhIMFYxOS41Mjk3TDIuNjQ2MyAxNi4zMTk3QzIuOTI5NzIgMTYuMDI2OSAzLjA1NTY5IDE1LjYxNjQgMi45ODc0NiAxNS4yMTU1VjQuMDgwMloiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPC9nPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iMCIgeTE9IjAiIHgyPSIxOS40Nzg3IiB5Mj0iMjQuNTM2MyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNzdCREZGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzBFNEVGRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgMedium as ReactComponent };